import React from 'react';

function UnderConstruction() {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            {/* Main content - grows to fill available space */}
            <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
                <div className="text-center max-w-4xl mx-auto">        
                    {/* Main heading */}
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-nunito">
                        Pardon our dust!
                    </h2>
                    
                    {/* Subheading */}
                    <h3 className="text-xl md:text-2xl font-light text-gray-600 mb-8 font-nunito leading-relaxed">
                        This page is still under construction. We're working hard to get this ready for you!
                    </h3>
                    
                    {/* Decorative element */}
                    <div className="mt-12 flex justify-center">
                        <div className="w-24 h-1 bg-gradient-to-r from-primary-light to-primary rounded-full"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnderConstruction;